import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import TableOpenTablesComponent from '../components/TableOpenTablesComponent';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';

// Listado de mesas abiertas (FR-001, FR-012). Molde: EventsPage.
class OpenTablesPage extends Component {

    constructor() {
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole
        }
    }

    async componentDidMount() {
        let role = await validateSession(true);
        this.setState({ checked: true, role: role });
    }

    addOpenTable = () => {
        navigateTo('/addOpenTable');
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={45} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <div className="d-flex justify-content-between align-items-center">
                                <HeaderComponent title="Cafetería" subtitle="Mesas abiertas" />
                                <button type="button" className="btn btn-accent" onClick={() => this.addOpenTable()}>
                                    + Publicar mesa abierta
                                </button>
                            </div>
                            <TableOpenTablesComponent />
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default OpenTablesPage;
